var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFullscreen = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 45,
  height: 45,
  viewBox: "0 0 45 45",
  preserveAspectRatio: "xMidYMid meet"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "fullscreen")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "fullscreen"
}, /*#__PURE__*/React.createElement("g", {
  id: "fullscreen-2",
  "data-name": "fullscreen"
}, /*#__PURE__*/React.createElement("g", {
  id: "circle"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 22.5,
  cy: 22.5,
  r: 20.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.5,2A20.5,20.5,0,1,1,2,22.5,20.53,20.53,0,0,1,22.5,2m0-2A22.5,22.5,0,1,0,45,22.5,22.52,22.52,0,0,0,22.5,0Z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "arrows"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "arrowBtm",
  points: "24.2 32.12 34.52 34.52 32.12 24.2 29.57 26.74 26.04 23.21 23.21 26.04 26.74 29.57 24.2 32.12",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "arrowTop",
  points: "20.8 12.88 10.48 10.48 12.88 20.8 15.43 18.26 18.96 21.79 21.79 18.96 18.26 15.43 20.8 12.88",
  fill: "#fff"
})))))));
export default SvgFullscreen;